/*
 * resetPinEproDevicePopupController
 * */
/* eslint-disable no-underscore-dangle */
class resetPinEproDevicePopupController {
	constructor($timeout, iSpiroService, loadingIndicatorService,
		signatureService, appI18n, appConfig, $stateParams, $q,
		ertBasePopupService, notificationService, userService, eproService) {
		'ngInject';
		this.$timeout = $timeout;
		this.$stateParams = $stateParams;
		this.iSpiroService = iSpiroService;
		this.loadingIndicatorService = loadingIndicatorService;
		this.signatureService = signatureService;
		this.ertBasePopupService = ertBasePopupService;
		this.notificationService = notificationService;
		this.userService = userService;
		this.eproService = eproService;
		this.appI18n = appI18n;
		this.appConfig = appConfig;
		this.$q = $q;
		this.onlineHelpId = 'MSP3.ClinicalData.ISpiro.ResetPinEproDevice';

		this.isLoading = false;
		this.$API = null;
		this.iSpiroForm = null;
		this.state = null;
		this.hasDOB = false;
		this.dobIsInFutureMsg = null;
		this.isFormValid = false;
		this.formData = null;
		this.subjectDemographics = null;
		this.additionalAttributes = null;
		this.studyContext = null;
		this.siteId = null;
		this.technicalSubjectId = null;
		this.subjectId = null;
		this.cancelBtn = null;
		this.isEdit = false;
		this.heading = 'Dispense Device';
		this.resetPinHeadingId = 'clinicaldata.subject.epro.resetPinHeading';
		this.displaySiteNames = [];
		this.displaySubjectKeys = [];
		this.provisionedAppId = null;
		this.protocolSetupLabels = [];
		this.resetPinText = appI18n.translateImmediate('clinicaldata.subject.epro.resetPinText');
		this.resetPinTextAfter = appI18n.translateImmediate(
			'clinicaldata.subject.i-spiro.close-dispense.resetPinTextAfter'
		);
		this.homeBResetPinText = appI18n.translateImmediate('clinicaldata.subject.i-spiro.close-dispense.homeBpResetPinText');


		this.errors = {
			genericError: false
		};

		// ACTION BUTTONS
		this.submitBtn = {
			action: () => {
				this.resetPin();
				this.clearActions();
			},
			cssClass: '-es-primary',
			displayName: 'app.buttons.submit',
			isDisabled: false,
			type: 'submit'
		};
		this.cancelBtn = {
			action: () => {
				this.cancelAction();
			},
			displayName: 'app.buttons.cancel',
			isDisabled: false
		};

		this.isEditBlocked = false;
	}

	$onInit() {

		this.configure();
		this.$API = this.setApi();
		this.componentReady && this.componentReady({ $API: this.$API });

		if (this.$stateParams.signKey) {
			const state = this.signatureService.getState(this.$stateParams.signKey);

			if (state) {
				if (state.sigType === this.getSignatureType()) {
					this.state = state;
				}
			}
		}
	}
	clearActions() {
		this.actions = [];
	}
	showQrCode(data, siteId, technicalSubjectId) {
		const provisonedAppData = data.find(d => d.context.appId === this.provisionedAppId);
		const qrCodePayload = {
			context: {
			  subjectContext: provisonedAppData.context.subjectContext,
			  participantId: '',
			  appId: provisonedAppData.context.appId,
			},
			type: 'AppResetPin',
			data: {
				lastPinReset: new Date().toISOString()
			}
		  };
		  
		  this.eproService.resetPinQR(
			provisonedAppData.context.appId,
			qrCodePayload,
			siteId,
			technicalSubjectId
		  ).then((response) => {
			const placeholderEl = angular.element(document).find('#reset-pin-placeholder');
			const deviceActionWidgetEl = angular.element('<device-action-reset-pin  />');
			deviceActionWidgetEl[0].qrCode = response.data.data.qrCodeContents;
			deviceActionWidgetEl[0].QRCodeValue = true;
			deviceActionWidgetEl[0].siteIds = this.displaySiteNames;
			deviceActionWidgetEl[0].subjectIds = this.displaySubjectKeys;
			deviceActionWidgetEl[0].infoText = this.resetPinTextAfter;
			deviceActionWidgetEl[0].vocabulary = this.protocolSetupLabels;
			placeholderEl.empty().append(deviceActionWidgetEl);
			this.loadingIndicatorService.hide();
		  }).catch(() => {
			this.loadingIndicatorService.hide();
		  });
	}
	showSuccessMessage() {
		const placeholderEl = angular.element(document).find('#device-action-dispense-placeholder');
		placeholderEl.empty().append('<h4>Subject data is updated.</h4>');
		this.loadingIndicatorService.hide();
	}

	resetPin() {
		this.loadingIndicatorService.show();

		this.eproService.resetPin(this.technicalSubjectId).then((response) => {
			this.showQrCode(response.data, this.siteId, this.technicalSubjectId);
		}).catch(() => {
			this.loadingIndicatorService.hide();
		});
	}

	configure() {
		this.popupHeading = 'clinicaldata.subject.i-spiro.close-dispense.dispenseTitle';
	}


	setApi() {
		const $API = {
			open: (isRemoteAction, countryId, siteId, technicalSubjectId, displaySiteName, subjectKey, subjectId, isHomeBpStudy) => {
				
				this.loadingIndicatorService.show();
				this.heading = this.resetPinHeadingId;
				this.siteId = siteId;
				this.technicalSubjectId = technicalSubjectId;
				this.isHomeBpStudy = isHomeBpStudy;

				this.actions = [this.submitBtn, this.cancelBtn];
				this.open = true;

				const protocolSetupLabelsPromise = this.eproService.getProtocolSetupLabels();
				const provisionedAppIdsPromise = this.eproService.getProvisionedAppIds(siteId, technicalSubjectId);

				this.$q.all([provisionedAppIdsPromise, protocolSetupLabelsPromise]).then((responses) => {
					const response = responses[0];
					const rawLabels = responses[1].data;
					const protocolSetupLabels = [
						rawLabels.find(l => l.fieldKey === 'IT_9')?.dfcLabel,
						rawLabels.find(l => l.fieldKey === 'PAT_SUBJECTID')?.dfcLabel
					].filter(Boolean);
					this.protocolSetupLabels = protocolSetupLabels;

					if (response.data.length === 1) {
						this.provisionedAppId = response.data[0];
						this.$timeout(() => {
							const placeholderEl = angular.element(document).find('#reset-pin-placeholder');
							const deviceActionWidgetEl = angular.element('<device-action-reset-pin  />');
							deviceActionWidgetEl[0].addEventListener('formDataChange', (event) => {
								const formData = event.detail;
								this.formData = formData;
							});
							deviceActionWidgetEl[0].addEventListener('formValidationChange', (event) => {
								const isFormValid = event.detail;
								this.isFormValid = isFormValid;
							});
							deviceActionWidgetEl[0].siteIds = [displaySiteName];
							deviceActionWidgetEl[0].subjectIds = [subjectKey];
							deviceActionWidgetEl[0].infoText = this.isHomeBpStudy ? this.homeBResetPinText : this.resetPinText;
							this.displaySiteNames = [displaySiteName];
							this.displaySubjectKeys = [subjectKey];
							deviceActionWidgetEl[0].vocabulary = this.protocolSetupLabels;
							placeholderEl.empty().append(deviceActionWidgetEl);
							this.loadingIndicatorService.hide();
						}, 200);
					}
				}).catch(() => {
					this.loadingIndicatorService.hide();
					this.notificationService.error('Error loading data');
				});
				
			},
			close: () => {
				this.open = false;
			}
		};
		return $API;
	}

	cancelAction() {
		this.$API.close();
	}

	getSignatureType() {
		return this.appConfig.sigType.noSignature;
	}

}
/* eslint-enable no-underscore-dangle */
export default resetPinEproDevicePopupController;
